import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface NewArrivalNoticeGenre {
  id: number
  genre: SystemCode
  opt1: string
}

export function NewArrivalNoticeGenreFromJSON(
  json: any
): NewArrivalNoticeGenre {
  return {
    id: json.id,
    genre: exists(json, 'genre')
      ? SystemCodeFromJSON(json.genre)
      : defaultSystemCode(),
    opt1: exists(json, 'opt1') ? json.opt1 : ''
  }
}
